(() => {
  const register = (name, initializer) => {
    if (window.SafeWalkV51Product?.register) window.SafeWalkV51Product.register(name, initializer);
    else (window.SafeWalkV51ProductQueue ||= []).push([name, initializer]);
  };

  register('offer-lines', ({ root, listen }) => {
    const currency = root.dataset.currency || 'ILS';
    const formatMoney = (cents) => {
      const value = Number(cents || 0) / 100;
      try {
        const hasAgorot = Math.abs(Number(cents || 0)) % 100 !== 0;
        return new Intl.NumberFormat('he-IL', {
          style: 'currency',
          currency,
          minimumFractionDigits: hasAgorot ? 2 : 0,
          maximumFractionDigits: 2
        }).format(value).replace(/\s/g, ' ');
      } catch (error) {
        return `${value.toFixed(2).replace(/\.00$/, '')} ₪`;
      }
    };
    const discounted = (variant, percent) => {
      return Math.round(Number(variant?.price || 0) * (100 - Number(percent || 0)) / 100);
	    };
    const renderLine = (card, key, variant, percent) => {
      const priceNode = card.querySelector(`[data-package-line-price="${key}"]`);
      const compareNode = card.querySelector(`[data-package-line-compare="${key}"]`);
      if (!priceNode && !compareNode) return;
      const currentPrice = variant ? discounted(variant, percent) : 0;
      const comparePrice = variant
        ? Number(variant.compare_at_price || variant.price || 0)
        : 0;
      if (priceNode) {
        priceNode.hidden = !variant;
        priceNode.textContent = variant ? formatMoney(currentPrice) : '';
      }
      if (compareNode) {
        const showCompare = Boolean(variant && comparePrice > currentPrice);
        compareNode.hidden = !showCompare;
        compareNode.textContent = showCompare ? formatMoney(comparePrice) : '';
      }
    };
    const renderCard = ({ card, state } = {}) => {
      if (!(card instanceof HTMLElement) || !state) return;
      renderLine(card, 'harness', state.mainVariant, state.discountPercent);
      renderLine(card, 'bungee', state.bungeeVariant, state.discountPercent);
      renderLine(card, 'collar', state.collarVariant, state.discountPercent);
    };

    listen(root, 'swv5:package-card-state', (event) => renderCard(event.detail));
  });
})();
